"use client";

import { SLLazyBackgroundVideo } from "@/components/other/SLLazyBackgroundVideo";
import { useMessages } from "@/lib/i18n/useMessages";
import { PhoneInTalk } from "@mui/icons-material";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "motion/react";
import NextLink from "next/link";
import { useState } from "react";
import { SLDialogAnrufen } from "../dialogs/SLDialogAnrufen";

export const SLAnimatedAnrufenButton = () => {
  const home = useMessages().home;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const isLg = useMediaQuery(theme.breakpoints.only("md"), { noSsr: true });

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          position: "relative",
          backgroundColor: "transparent",
          borderRadius: `${theme.shape.borderRadius}px`,
          overflow: "clip",
          my: isMobile ? 0 : 2,
        }}
      >
        <SLLazyBackgroundVideo />

        <Button
          variant="contained"
          component={motion.div}
          animate={{ width: "100%", height: "100%" }}
          size="medium"
          LinkComponent={NextLink}
          startIcon={<PhoneInTalk />}
          onClick={handleOpen}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            position: "relative",
            backgroundColor: "transparent",
            color: theme.palette.background.default,
            "&:hover": {
              backgroundColor: "transparent",
              color: theme.palette.background.default,
              transition: "all 0.3s ease",
            },
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              component: "span",
            }}
          >
            {isLg ? home.header.callToActionShort : home.header.callToAction}
          </Typography>
        </Button>
      </Box>

      <SLDialogAnrufen open={open} handleClose={handleClose} />
    </>
  );
};
